import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { MiniatureQuotedMessage } from 'APP/main/ChatView/components/MiniatureQuotedMessage/MiniatureQuotedMessage';
import { Quote } from 'STORE/Messages/Message/Quote/Quote';

import { TRepliedMessageTheme } from '../RepliedMessage/RepliedMessage';
import { useQuotedTextPresenter } from './QuotedText.presenter';
import styles from './QuotedText.styles.m.css';
import { QuotedTextTitle } from './QuotedTextTitle/QuotedTextTitle';

interface IQuotedTextProps {
  quote?: Quote;
  className?: string;
  parentMessageId: string;
  theme?: TRepliedMessageTheme;
}

export const QuotedText: FC<IQuotedTextProps> = observer((props) => {
  const { quote, className, parentMessageId, theme = '1' } = props;
  const presenter = useQuotedTextPresenter({ quote, parentMessageId });
  if (!presenter.quote) {
    return null;
  }

  return (
    <div
      className={classNames(styles.container, styles[`theme-${theme}`], className)}
      data-test="quote-message-text"
    >
      <div className={styles.content}>
        <MiniatureQuotedMessage
          onClick={presenter.onClick}
          quote={presenter.quote}
          preventInteraction={presenter.isLoading}
          isTextExpanded={presenter.isTextExpanded}
          title={
            <QuotedTextTitle
              isLoading={presenter.isLoading}
              className={styles.title}
              title={presenter.title}
            />
          }
        />
      </div>
    </div>
  );
});
